import { getProviders } from '@services/queries'
import { useQuery } from 'react-query'

export function useProviders() {
  const info = useQuery(['providers'], getProviders)

  return info
}
